import axios from 'axios'
import { errorCode } from './constants'
import { getRefreshToken, logout } from './redux/actions/auth'

let isRefreshing = false
let requestQueue = []

const processQueue = (error, token = null) => {
  requestQueue.forEach(promise => {
    if (error) {
      promise.reject(error)
    } else {
      promise.resolve(token)
    }
  })

  requestQueue = []
}

let getInfoRequestCount = 0

export default {
  setupInterceptors: store => {
    //add a request interceptor
    axios.interceptors.request.use(config => {
      const { url, method } = config
      const isGetInfoRequest =
        url.includes('/user/v1.1/accounts') && method === 'get'
      if (isGetInfoRequest) {
        getInfoRequestCount++
      }
      if (isGetInfoRequest && getInfoRequestCount > 1) {
        return {
          ...config,
          cancelToken: new axios.CancelToken(cancel =>
            cancel('Cancel repeated request')
          )
        }
      }

      config.headers['Accept-Language'] = 'en'

      return config
    })

    // Add a response interceptor
    axios.interceptors.response.use(
      response => {
        const { config } = response
        const { url, method } = config
        const isGetInfoRequest =
          url.includes('/user/v1.1/accounts') && method === 'get'
        //reset get info request when there has response
        if (isGetInfoRequest) {
          getInfoRequestCount = 0
        }
        return response
      },
      err => {
        if (!err.response) {
          throw err
        }
        const { error } = err.response.data

        if (
          error.code === errorCode.INVALID_SESSION_TOKEN ||
          error.message === 'Session InvalidSessionToken'
        ) {
          console.log('token expired, need refreshing')
          const originalRequest = err.config
          const dispatch = store.dispatch
          if (!originalRequest._retry) {
            //when request refresh token is process, push parallel request to queue
            if (isRefreshing) {
              return new Promise((resolve, reject) => {
                requestQueue.push({ resolve, reject })
              })
                .then(token => {
                  axios.defaults.headers.common['Authorization'] = token
                  originalRequest.headers['Authorization'] = token
                  return axios(originalRequest)
                })
                .catch(err => {
                  console.log(err)
                })
            }

            originalRequest._retry = true
            isRefreshing = true

            return new Promise((resolve, reject) => {
              dispatch(getRefreshToken())
                .then(data => {
                  //error or refresh token
                  if (data.error) {
                    // logout
                    dispatch(logout())
                    return (window.location.href = '/')
                  }
                  const newToken = data.data.accessToken
                  axios.defaults.headers.common['Authorization'] = newToken
                  originalRequest.headers['Authorization'] = newToken
                  resolve(axios(originalRequest))
                  //process parallel request queue after with new token
                  processQueue(null, newToken)
                })
                .catch(() => {
                  return dispatch(logout())
                  // return (window.location.href = '/')
                })
                .then(() => {
                  isRefreshing = false
                })
            })
          }
        } else {
          throw err
        }
      }
    )
  }
}
